import { envsafe, MissingEnvError, str, url } from 'envsafe';

//TODO: проверить нужны ли тут все переменные
export const LAST_PATH_STORAGE_KEY = 'lastPath';
export const FORM_STATE_STORAGE_KEY = 'formState';
export const ESIA_CODE_STORAGE_KEY = 'esiaCode';
export const SESSION_ID_STORAGE_KEY = 'sessionId';
export const LAST_KEYCLOAK_SUBJECT_STORAGE_KEY = 'lastKeycloakSubject';
export const QUESTIONNAIRE_SUMBITTED_ERROR = 'Questionnaire already submitted.';

export const PEREKRESTOK_BUSINESS_UNIT = 'RU06';
export const PYATEROCHKA_BUSINESS_UNIT = 'RU02';
export const CHIZIK_BUSINESS_UNIT = 'RUP9';


export const env = envsafe(
  {
    API_URL: url(),
    X5_KEY_UI_HOST: url(),
    X5_KEY_CANDIDATE_OFFICE_REALM: str(),
    X5_KEY_CANDIDATE_OFFICE_CLIENT_ID: str(),
    X5_KEY_CANDIDATE_MASS_REALM: str(),
    X5_KEY_CANDIDATE_MASS_CLIENT_ID: str(),
    NODE_ENV: str({
      default: 'development',
      choices: ['development', 'production'],
    }),
  },
  {
    reporter({ errors }) {
      const keys = Object.keys(errors);

      const invalids: string[] = [];
      const missing: string[] = [];

      for (const key of keys) {
        const err = errors[key];
        if (err instanceof MissingEnvError) {
          missing.push(`    ${key}: ${err.message || 'required'}`);
        } else {
          invalids.push(`    ${key}: ${err?.message || 'invalid'}`);
        }
      }
      if (invalids.length) {
        invalids.unshift('❌ Invalid environment variables:');
      }
      if (missing.length) {
        missing.unshift('🕵️ Missing environment variables:');
      }

      const output: string[] = [
        '========================================',
        ...invalids,
        ...missing,
        '========================================',
      ];
      throw new Error(output.join('\n'));
    },
  },
);
